(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ftd-shop-cta"] && !Shopify.designMode) return;
  try {
    if (!window.__ftdShopCtaScroll) {
    window.__ftdShopCtaScroll = true;
    document.addEventListener('click', function (event) {
      const origin = event.target instanceof Element ? event.target : event.target.parentElement;
      const scrollTrigger = origin && origin.closest('a[href="#pdp-main"]');
      if (!scrollTrigger) return;

      const targetElement =
        document.querySelector('#pdp-main') ||
        document.querySelector('.pdp-main-section') ||
        document.querySelector('pdp-bundle-builder') ||
        document.querySelector('.product-main-section');
      if (!targetElement) return;

      event.preventDefault();
      const header = scrollTrigger.closest('fortified-header');
      if (header && typeof header.close === 'function') header.close();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.requestAnimationFrame(function () {
        targetElement.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
